import { Appointment } from 'vl-common/src/schemas/shared';
import assert from 'assert';

const defaultSignallingType = 'ws';

export function useVideoCallSignallingType(a: Appointment): 'ws' | 'dt' {
  assert(a, 'Appointment must be loaded to switch between WS and DT signalling');

  if (!a.client_case_id) {
    console.warn('Appointment missing client_case_id');
    return defaultSignallingType;
  }

  const case_ref = a.client_case_id;

  if (case_ref.endsWith('*+')) return 'dt';
  if (case_ref.endsWith('*-')) return 'ws';

  return defaultSignallingType;
}
